import React, { useState } from "react";
import Global from "../Global/Global";

const Banner3 = ({ id, data }) => {
    
    const {urls, callAlert, callApi} = Global();
  const [form, setForm] = useState({
    name: "",
    email: "",
    contact_no: "",
    address: "",
    pincode: "",
    msg: "",
    i_am_a: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      required: "name,contact_no,upi_transaction_id",
      tag: "My Book",
      pageurl: window.location.href,
    };

    const resp = await callApi(payload, "formSubmitReact", "POST", true)
    if(resp.status !== undefined && resp.status === "OK"){
        window.callAlert(resp.message, "successAlert")
        window.location.href="/policy/"+resp.enqid
    }
  };

  const radios = [1, 2, 3, 4];

  return (
    <div
      className="banner_3 relative"
      id={`id${id}`}
      style={{ backgroundImage: `url(${data?.bgImgold})` }}
    >
      {/* Circles */}
      {[1, 2].map((i) => (
        <div key={i} className={`circle circle${i} absolute`} />
      ))}

      <div className="width90 maxWidth1300 floatCenter">
        <div className="grid grid2 gap100 alignCenter">
          {/* Left Section */}
          <div className="leftSec">
            <div className="imgSec">
              <a href={data?.logoLink} title={data?.logoAlt}>
                <img
                  className="contain"
                  src={urls.assets + data?.logoold}
                  alt={data?.logoAlt}
                />
              </a>
            </div>

            <p className="mainHeading">{data?.mainHeading}</p>

            <p
              className="subPara"
              dangerouslySetInnerHTML={{ __html: data?.subPara }}
            />
          </div>

          {/* Form Section */}
          <div className="formMainSec">
            <div className="formSec">
              <form onSubmit={handleSubmit}>
                <p className="formHead textCenter">{data?.formHead}</p>

                <input
                  className="inputSec"
                  type="text"
                  placeholder="Full Name*"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />

                <input
                  className="inputSec"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />

                <input
                  className="inputSec"
                  type="number"
                  placeholder="Phone Number*"
                  name="contact_no"
                  value={form.contact_no}
                  onChange={handleChange}
                  required
                />

                <input
                  className="inputSec"
                  type="text"
                  placeholder="Full Address"
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                />

                <input
                  className="inputSec"
                  type="number"
                  placeholder="Pincode"
                  name="pincode"
                  value={form.pincode}
                  onChange={handleChange}
                />

                <textarea
                  className="inputSec"
                  rows="3"
                  placeholder="UPI Transaction ID*"
                  name="upi_transaction_id"
                  value={form.upi_transaction_id}
                  onChange={handleChange}
                  required
                />

                {/* Radio Section */}
                {data?.radioText && (
                  <div className="radioMainSec">
                    <p className="radioPara">{data?.radioText}</p>

                    <div className="grid grid3 gap20">
                      {radios.map(
                        (i) =>
                          data?.[`radio${i}`] && (
                            <div key={i} className="radioBtnMainSec">
                              <input
                                type="radio"
                                name="i_am_a"
                                value={data?.[`radio${i}`]}
                                checked={
                                  form.i_am_a === data?.[`radio${i}`]
                                }
                                onChange={handleChange}
                                id={data?.[`radio${i}`]}
                              />
                              <label
                                className="labelText"
                                htmlFor={data?.[`radio${i}`]}
                              >
                                {data?.[`radio${i}`]}
                              </label>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                )}

                <div className="textCenter">
                  <button type="submit" className="submit">
                    {data?.formBtnText}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner3;